import {Link} from "react-router-dom";
import {Logo, MasterCard, Mir, Sbp, Visa} from "../Assets";
import {TripAdvisor} from "../Assets";
import {Vk} from "../Assets";
import {Yandex} from "../Assets";
import {Gis} from "../Assets";
import {motion} from "framer-motion";

const Footer = () => {
    const paymentsIconsStyle = {
        whiteSpace: 'nowrap'
    }

    const paymentsIconStyle = {
        display: 'inline-block',
        width: '64px',
        margin: '5px'
    }
    return (
        <footer className="p-4 bg-primary sm:p-6 w-full">
            <div className="flex flex-col items-center justify-center md:flex-row md:justify-between">
                <motion.div
                    whileHover={{rotate: [0, -1, 1, -1, 0]}}
                >
                    <Link to="/" className="flex gap-8 items-center">
                        <motion.img
                            whileHover={{rotate: [0, -1, 1, -1, 0]}}
                            src={Logo}
                            className="w-12 md:w-20 object-contain"
                            alt="Logo"
                        />
                        <span className="self-center text-2xl font-semibold whitespace-nowrap text-headingColor">
                          MonTresor
                        </span>
                    </Link>
                </motion.div>
                <div>
                    <motion.ul
                        initial={{opacity: 0, x: 200}}
                        animate={{opacity: 1, x: 0}}
                        exit={{opacity: 0, x: 200}}
                        className="flex items-center gap-8"
                    >
                        <motion.li
                            whileHover={{scale: 1.1}}
                            className="w-7 md:w-10 object-contain"
                        >
                            <Link
                                to="https://www.tripadvisor.ru/Restaurant_Review-g777986-d12454495-Reviews-Mon_Tresor-Yoshkar_Ola_Mari_El_Republic_Volga_District.html"
                                target="_blank">
                                <img
                                    src={TripAdvisor}
                                    alt="TripAdvisor"
                                />
                            </Link>
                        </motion.li>
                        <motion.li
                            whileHover={{scale: 1.1}}
                            className="w-7 md:w-10 object-contain"
                        >
                            <Link to="https://vk.com/montresorrestobar" target="_blank">
                                <img
                                    src={Vk}
                                    alt="Vk"
                                />
                            </Link>
                        </motion.li>
                        <motion.li
                            whileHover={{scale: 1.1}}
                            className="w-6 md:w-8 object-contain"
                        >
                            <Link to="https://yandex.ru/maps/org/mon_trezor/126777242974/?ll=47.928515%2C56.631119&z=10"
                                  target="_blank">
                                <img
                                    src={Yandex}
                                    alt="Yandex"
                                />
                            </Link>
                        </motion.li>
                        <motion.li
                            whileHover={{scale: 1.1}}
                            className="w-10 md:w-14 object-contain"
                        >
                            <Link to="https://2gis.ru/yoshkarola/firm/70000001027007463"
                                  target="_blank">
                                <img
                                    src={Gis}
                                    alt="Gis"
                                />
                            </Link>
                        </motion.li>
                    </motion.ul>
                </div>
            </div>
            <hr className="my-2 border-gray-200 sm:mx-auto dark:border-gray-700 lg:my-8"/>
            <div className="flex flex-col items-center justify-center md:flex-row md:justify-between">
                <div style={paymentsIconsStyle}>
                    <img src={Visa} alt="Visa" style={paymentsIconStyle}/>
                    <img src={MasterCard} alt="MasterCard" style={paymentsIconStyle}/>
                    <img src={Mir} alt="МИР" style={paymentsIconStyle}/>
                    <img src={Sbp} alt="СБП" style={paymentsIconStyle}/>
                </div>
                <span className="text-sm text-gray-500 text-center dark:text-gray-400">
                    <ul>
                        <li>© 2025 ООО "МВС"</li>
                        <li>424038, Республика Марий Эл, город Йошкар-Ола, ул. Кирова, д. 9б</li>
                        <li>ИНН 1215187738 / КПП 121501001</li>
                        <li>Почта: mon_tresor@bk.ru</li>
                        <li>Телефон: +7 (902) 739 74 07</li>
                    </ul>
                </span>
                <span className="text-sm text-gray-500 text-center dark:text-gray-400">
                    <ul>
                        <li>
                            <Link to="/public_offer">
                                Публичная оферта
                            </Link>
                        </li>
                        <li>
                            <Link to="/privacy_policy">
                                Политика конфиденциальности
                            </Link>
                        </li>
                    </ul>
                </span>
            </div>
        </footer>
    );
};

export default Footer;
